export default "__VITE_ASSET__CAbehXXr__"